import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupDataService } from '../services/lookup-data.service';

@Pipe({
  name: 'major',
  pure: true
})
export class MajorPipe implements PipeTransform {
  constructor(private lookupData: LookupDataService) {}

  transform(value: any | string | null | undefined): Observable<string> {
    if (value === null || value === undefined || value === '') {
      return of('Major not set');
    }
    return this.lookupData.getMajors({
      selectedIds: [String(value)],
      pageNumber: 1,
      pageSize: 1
    }).pipe(
      map(result => {
        const major = result.items.find(m => String(m.id) === String(value));
        return major?.name ?? 'Major not set';
      })
    );
  }
}
